import React, { useState } from 'react'
import userImage from '@/assets/img/user-1.png'
import { CustomerHistory } from '@/types/dispatcher/dashboard.types'
import Image from '@/compoments/common/Image'
import { format } from 'date-fns'
import { getMediaUrl } from '@/utils/helpers'
import Button from '@/compoments/common/Button'
import AddOrderModal from '@/compoments/modals/AddOrderModal'
import { useParams } from 'react-router-dom'
import ChevronDownIcon from '@/assets/img/ico-chevro-down.svg?react'

const UserPart = ({ data }: { data?: CustomerHistory }) => {
    const { id } = useParams()
    const [addOrderModalOpen, setAddOrderModalOpen] = useState(false)
    return (
        <div className="card-user-info mb-18 gap--lg">
            <div className="card-user-info__item flex items-center gap-18">
                <div className="user-photo-60x60">
                    <Image
                        src={getMediaUrl(data?.photo) || ''}
                        width={60}
                        height={60}
                        alt="user"
                    />
                </div>

                <div className="flex flex-col">
                    <h5 className="mb-4px">{data?.fullName}</h5>
                    <span className="text--xs text-color-1">{data?.email}</span>
                    <span className="text--xs text-color-1">{data?.phone}</span>
                </div>
            </div>
            <div className="card-user-info__item flex flex-col items-center">
                <h2 className="mb-10">{data?.total}</h2>
                <span className="text--xs text-color-1">Services</span>
            </div>
            <div className="card-user-info__item flex flex-col items-center">
                <h2 className="mb-10">
                    {data?.lastService
                        ? format(data?.lastService, 'dd-MM-yyyy')
                        : 'not specified'}
                </h2>
                <span className="text--xs text-color-1">Last Service</span>
            </div>
            <div className="card-user-info__item flex flex-col items-center">
                <h2 className="mb-10">{data?.feedback}</h2>
                <span className="text--xs text-color-1">Feedback</span>
            </div>

            <div className="row-group gap--xs ml-auto">
                <Button
                    onClick={() => setAddOrderModalOpen(true)}
                    size="sm"
                    variant="primary-gradient"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.8327 9.16675H10.8327V4.16675H9.16602V9.16675H4.16602V10.8334H9.16602V15.8334H10.8327V10.8334H15.8327V9.16675Z"
                            fill="white"
                        ></path>
                    </svg>
                    <span className="text--xs">Add Order</span>
                </Button>
            </div>
            {addOrderModalOpen && (
                <AddOrderModal
                    customerId={Number(id)}
                    isOpen={addOrderModalOpen}
                    onClose={() => setAddOrderModalOpen(false)}
                />
            )}
        </div>
    )
}

export default UserPart
